import React from 'react';

import { Button, Modal, ImportBox } from '@unimed-fesp/components';

import { ModalContent, ModalContentWrapper } from '../../molecules/Modal';
import { shapeFile, customValidations } from '../../../utils/file';

import { ContentText } from './styles';

function ModalFileImport({
  contentText,
  modeloPadrao,
  contentModeloPadrao = null,
  isOpen,
  onClick,
  setListaFiles,
  importFiles,
  maxQuantityFiles,
  maxSizeFiles,
  validExtension,
  applyValidation,
  invalidCallback = () => {},
}) {
  return (
    <Modal
      width={600}
      isOpen={isOpen}
      onClick={onClick}
      header={<>importar</>}
      footer={<ModalFooter onClick={onClick} />}
      justifyContentFooter="flex-end"
    >
      <ModalContentWrapper>
        <ModalContent
          overflow="hidden"
          width="600px"
          height="auto"
          maxHeight="none"
        >
          <ImportBox
            maxWidth={600}
            contentText={<ContentText>{contentText}</ContentText>}
            templateDownloadText={
              <TemplateDownloadText
                modeloPadrao={modeloPadrao}
                contentModeloPadrao={contentModeloPadrao}
              />
            }
            shapeFile={shapeFile}
            setListaFiles={setListaFiles}
            applyValidation={applyValidation}
            customValidations={(filesInput) =>
              customValidations(
                filesInput,
                maxSizeFiles,
                maxQuantityFiles,
                validExtension,
                invalidCallback
              )
            }
          />
        </ModalContent>
      </ModalContentWrapper>
    </Modal>
  );
}
const ModalFooter = ({ onClick }) => {
  return (
    <>
      <Button
        tipo="secondary"
        justifyCenter
        alignCenter
        marginRight={10}
        font="16px unimed_slabregular"
        width={100}
        onClick={onClick}
      >
        cancelar
      </Button>
      <Button
        tipo="primary"
        justifyCenter
        alignCenter
        disabled
        opacity={0.4}
        font="16px unimed_slabregular"
        width={100}
      >
        importar
      </Button>
    </>
  );
};

const TemplateDownloadText = ({ modeloPadrao, contentModeloPadrao }) =>
  contentModeloPadrao ? (
    <ContentText>{contentModeloPadrao}</ContentText>
  ) : (
    <ContentText>
      Para te auxiliar, temos um
      <a href={modeloPadrao?.path} download={modeloPadrao?.nomeArquivo}>
        {' '}
        modelo padrão{' '}
      </a>
      demonstrando como as informações devem ser preenchidas.
    </ContentText>
  );

export default ModalFileImport;
